// shim.js — classic script (NOT type="module"), loads before ES modules
// Provides real cookie implementations so inline scripts and third-party apps
// (Klaviyo, Yotpo, Judge.me) can call getCookie() before utils.js module loads.
// When utils.js loads later, it overwrites these with canonical versions.
window.theme = window.theme || {};
window.theme._ready = new Promise(function(resolve) { window.theme._resolveReady = resolve; });

function getCookie(name) {
  var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return v ? decodeURIComponent(v.pop()) : '';
}
function setCookie(name, value, days) {
  var d = new Date(); d.setTime(d.getTime() + (days || 365) * 864e5);
  document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
}
function deleteCookie(name) { setCookie(name, '', -1); }

window.getCookie = window.theme.getCookie = getCookie;
window.setCookie = window.theme.setCookie = setCookie;
window.deleteCookie = window.theme.deleteCookie = deleteCookie;
